module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-layout-header', {
    staticStyle: {
      "background": "#fff",
      "padding": "0",
      "line-height": "90px",
      "height": "90px",
      "min-width": "1224px"
    }
  }, [_c('a-icon', {
    staticClass: "trigger",
    attrs: {
      "type": _vm.collapsed ? 'menu-unfold' : 'menu-fold'
    },
    on: {
      "click": _vm.toggleCollapsed
    }
  }), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "value": _vm.now_app_state
    },
    on: {
      "change": _vm.onSearch
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("\n\t\t\t全部\n\t\t")]), _vm._v(" "), _vm._l((_vm.apps_list), function(app) {
    return _c('a-select-option', {
      key: app.id,
      attrs: {
        "value": app.id
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(app.app_name) + "\n\t\t")])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "300px",
      "height": "100%",
      "margin-right": "15px",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "display": "inline-block"
    }
  }, [(_vm.userinfo.avatar) ? _c('a-avatar', {
    attrs: {
      "size": 64,
      "shape": "circle",
      "src": _vm.userinfo.avatar
    }
  }) : _c('a-avatar', {
    attrs: {
      "size": 64,
      "icon": "user"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "display": "inline-block",
      "margin-right": "10px",
      "line-height": "30px",
      "margin-top": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.userinfo.email))]), _vm._v(" "), _c('a-dropdown', {
    staticStyle: {
      "margin-left": "50px"
    }
  }, [_c('a', {
    staticClass: "ant-dropdown-link tophover",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n\t\t\t\t\t更多操作\n\t\t\t\t\t"), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1), _vm._v(" "), _c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("二次认证")])]), _vm._v(" "), _c('a-menu-item', [_c('router-link', {
    attrs: {
      "to": "forgotpassword"
    }
  }, [_c('span', [_vm._v("修改密码")])])], 1), _vm._v(" "), _c('a-menu-item', [_c('span', {
    on: {
      "click": _vm.quit
    }
  }, [_vm._v("退出登录")])])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bdd8229","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/components/top_bar.vue
// module id = 2363
// module chunks = 1